"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initConfig_1 = require("./Init/initConfig");
var Version_1 = require("./temp/Version");
exports.VERSION = Version_1.default;
var NAME = 'DAZN Shaka Heuristic';
exports.NAME = NAME;
exports.default = initConfig_1.default;
//# sourceMappingURL=index.js.map